import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { isLoggedIn } from 'identity/selectors'
import { loginRequest } from 'quick-quote/actions'
import { isOnFnaPhase } from 'quick-quote/fna/selectors'
import { setNotificationMessage } from 'quick-quote/notification/actions'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'
import { getIsUserOnline } from 'quick-quote/selectors'

import { setSelectedNeedId, setFnaGapValue } from './actions'
import { Form } from './components'
import {
  getNeeds,
  getQuestions,
  getPlans,
  getSelectedPlanId,
  getPlanByPlanId,
  getSelectedNeedType,
  getNeedGapQuestion,
  getNeedGapTargetSavings,
} from './selectors'

const mapStateToProps = (state) => {
  const needs = getNeeds(state)
  const plans = getPlans(state)
  const needGapQuestions = getNeedGapQuestion(state)
  const questions = _.mapValues(getQuestions(state), (q) => ({ ...q, value: needGapQuestions[q.id] }))
  const selectedNeedId = getSelectedNeedType(state)
  const selectedPlanId = getSelectedPlanId(state)
  const needPlan = getPlanByPlanId(plans, selectedPlanId)
  const targetSavings = getNeedGapTargetSavings(state)
  const onFnaPhase = isOnFnaPhase(state)
  const isUserLogin = isLoggedIn(state)
  const isUserOnline = getIsUserOnline(state)

  return {
    needs,
    questions,
    needPlan,
    selectedNeedId,
    selectedPlanId,
    targetSavings,
    onFnaPhase,
    selectedDisplayProductCode: getSelectedDisplayProductCode(state),
    isUserLogin,
    isUserOnline,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedNeedId: bindActionCreators(setSelectedNeedId, dispatch),
    setQuestion: bindActionCreators(setFnaGapValue, dispatch),
    needLogin: bindActionCreators(loginRequest, dispatch),
    setNotification: bindActionCreators(setNotificationMessage, dispatch),
  }
}

export const NeedAndGapAnalysisContainer = connect(mapStateToProps, mapDispatchToProps)(Form)

export default NeedAndGapAnalysisContainer
